import {Box, Flex, Slider, SliderTrack, SliderFilledTrack, SliderThumb, Text} from "@chakra-ui/react";
import {useState} from "react";
import {Tooltip} from "@chakra-ui/react";

export default function ThresholdSelector({threshold, setThreshold, handleSubmit}) {
    const [showTooltip, setShowTooltip] = useState(false)
    return (
        <Box h='40px' borderRadius='10px' align='center' px='10px'>
            <Flex direction="row">
                <Text mr="20px">Threshold</Text>
                <Slider aria-label='slider-threshold' min={-30} max={10} step={0.5} value={threshold}
                        onChange={(val) => setThreshold(val)}
                        onChangeEnd={(val) => handleSubmit(val)}
                        onMouseEnter={() => setShowTooltip(true)}
                        onMouseLeave={() => setShowTooltip(false)}>
                    <SliderTrack bg='gray.300'>
                        <SliderFilledTrack/>
                    </SliderTrack>
                    <Tooltip
                        hasArrow
                        bg='gray.600'
                        color='white'
                        placement='top'
                        isOpen={showTooltip}
                        label={`${threshold}`}
                    >
                        <SliderThumb/>
                    </Tooltip>
                </Slider>
            </Flex>
        </Box>
    )
}